import { render, staticRenderFns } from "./mendian.vue?vue&type=template&id=50f163f3&scoped=true"
import script from "./mendian.vue?vue&type=script&lang=ts"
export * from "./mendian.vue?vue&type=script&lang=ts"
import style0 from "./mendian.vue?vue&type=style&index=0&id=50f163f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f163f3",
  null
  
)

export default component.exports